export const selectLogos = (state) => state.banner.logos;

export const selectBanner = (state) => state.banner.banner;
